import { WidthFull, WidthNormal } from "@mui/icons-material";
import { Grid, Box, IconButton, Tooltip } from "@mui/material";
import React, { useEffect, useState, ReactNode } from "react";


interface IExpandableContainerProps {
    children: ReactNode;
}

export const ExpandableContainer: React.FC<IExpandableContainerProps> = ({ children }) => {

    const [fullWidth, setFullWidth] = useState(false);
    const [prompt, setPrompt] = useState(false);

    useEffect(() => {
        const storedValue = localStorage.getItem('fullWidth');
        if (storedValue !== null) {
            setFullWidth(JSON.parse(storedValue));
        }
    });

    const toggleExpand = () => {
        localStorage.setItem('fullWidth', JSON.stringify(!fullWidth))
        setFullWidth(!fullWidth)
    }



    return (
        <Box sx={{
            maxWidth: fullWidth ? "100%" : "1300px",
            marginLeft: "auto",
            marginRight: "auto"
        }}>
            <Tooltip title={fullWidth ? "Display in Standard Width" : "Display in Full Width"}>
                <IconButton
                    onClick={toggleExpand}
                    sx={{ position: "absolute", right: "2em", opacity: 0.5 }}
                    color={prompt ? "warning" : "default"}

                >
                    {fullWidth ? <WidthNormal /> : <WidthFull />}
                </IconButton>
            </Tooltip>


            {children}
        </Box>
    );
}